import {ValidationError} from "./validation";

const specialCharRegex = /[!@#$%^&()_+{};':"\\|,.<>/?[\]]/;

function getPasswordError(value: string): ValidationError | null {
    if (value.length < 10) return {key: "passwordValidation.minLength"};
    if (!/[A-Z]/.test(value)) return {key: "passwordValidation.uppercase"};
    if (!/[a-z]/.test(value)) return {key: "passwordValidation.lowercase"};
    if (!/\d/.test(value)) return {key: "passwordValidation.digit"};
    if (!specialCharRegex.test(value)) return {key: "passwordValidation.specialChar"};
    return null;
}

export function validatePassword(value: string): ValidationError | null {
    return getPasswordError(value);
}

export function validatePasswordMatch(
    password: string,
    confirmation: string,
    errorKey = "passwordValidation.match"
): ValidationError | null {
    if (password !== confirmation) {
        return {key: errorKey};
    }
    return null;
}

export function validatePasswordMatchWhenBothPresent(
    password: string,
    confirmation: string,
    errorKey = "passwordValidation.match"
): ValidationError | null {
    if (!password || !confirmation) {
        return null;
    }
    return validatePasswordMatch(password, confirmation, errorKey);
}

export function validatePasswordMatchWhenConfirmationPresent(
    password: string,
    confirmation: string,
    errorKey = "passwordValidation.match"
): ValidationError | null {
    if (!confirmation) {
        return null;
    }
    return validatePasswordMatch(password, confirmation, errorKey);
}
